import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const StudentAuthContext = createContext(null);

const studentApi = axios.create({ baseURL: API_URL });

studentApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('student_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

studentApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes('student-login')) {
      localStorage.removeItem('student_token');
      localStorage.removeItem('student_user');
      window.location.href = '/student-login';
    }
    return Promise.reject(err);
  }
);

export const StudentAuthProvider = ({ children }) => {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window.location.pathname === '/counselling') { setLoading(false); return; }
    const saved = localStorage.getItem('student_user');
    const token = localStorage.getItem('student_token');
    if (saved && token) {
      setStudent(JSON.parse(saved));
    }
    setLoading(false);
  }, []);

  const login = async (loginId, password) => {
    const res = await studentApi.post('/api/student-auth/login', { login_id: loginId, password });
    const { access_token, student: studentData } = res.data;
    localStorage.setItem('student_token', access_token);
    localStorage.setItem('student_user', JSON.stringify(studentData));
    setStudent(studentData);
    return studentData;
  };

  const logout = () => {
    localStorage.removeItem('student_token');
    localStorage.removeItem('student_user');
    setStudent(null);
  };

  const changePassword = async (currentPassword, newPassword) => {
    await studentApi.post('/api/student-auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    });
    setStudent(prev => ({ ...prev, must_change_password: false }));
    localStorage.setItem('student_user', JSON.stringify({ ...student, must_change_password: false }));
  };

  return (
    <StudentAuthContext.Provider value={{ student, loading, login, logout, changePassword, studentApi }}>
      {children}
    </StudentAuthContext.Provider>
  );
};

export const useStudentAuth = () => useContext(StudentAuthContext);
export { studentApi };
